import React from "react";
import styles from "./modals.module.scss";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
import { IModalInstance } from "./ModalProvider";

export const ModalHeader: React.FC<IModalInstance<any>> = ({ children, closeModal }) => {
  return (
    <>
      {children ? <span>{children}</span> : null}
      <Svg iconName={`close`} width={14} height={14} onClick={() => closeModal()} className={styles.headerClose} />
    </>
  );
};
